// extracted by mini-css-extract-plugin
export default {"container":"DocumentTable_container__zmmDC","navLink":"DocumentTable_navLink__Gr4LF"};